/*
 * サブシステム名：請求消込
 * 機能名：未入金一覧
 */
import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import validators from '@/rahmen/validators'

import header from '@/ddv2.library/header'

const DdSearchList = () => import('@/components/DdSearchList')
const DdCodeTextBox = () => import('../../components/DdCodeTextBox.vue')
const DdCheckbox = () => import('@/components/DdCheckbox')
const DdDateRangeBox = () => import('@/components/DdDateRangeBox')

export default {
  name: 'MiNyukinList',
  mixins: [flowMixin],
  components: {
    DdSearchList,
    DdCodeTextBox,
    DdCheckbox,
    DdDateRangeBox
  },
  data: () => ({
    // 一覧制御用
    selected: [],
    itemsPerPage: 100,
    page: 1,
    isConditionHide: false,
    isCsvDownloader: false,
    isPdfDownloader: false,

    conditions: {
      seikyusakiCd: '',
      nyukinYoteiYmdFromString: '',
      nyukinYoteiYmdToString: '',
      tantoCd: '',
      nyukinYoteiChoka: ''
    },
    headersJininList: header.mstJininHeaders,
    headersSeikyusakiList: header.mstTorihikisakiHeaders,
    modeKengen: 0
  }),
  computed: {
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        // 表示フォーマット編集
        if (elem.seikyuYmd !== null) {
          elem.seikyuYmdDisp = filter.dateFormatter(elem.seikyuYmd)
        }
        if (elem.nyukinYoteiYmd !== null) {
          elem.nyukinYoteiYmdDisp = filter.dateFormatter(elem.nyukinYoteiYmd)
        }
        elem.seikyuKingakuDisp = filter.numericFormatter(elem.seikyuKingaku)
        elem.nyukinKingakuDisp = filter.numericFormatter(elem.nyukinKingaku)
        elem.minyukinKingakuDisp = filter.numericFormatter(elem.minyukinKingaku)
        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      jininList: 'DDMasters/vwCMstEigyoshoJininList',
      seikyusakiList: 'DDMasters/vwCMstTorihikisakiGetSeikyusaki',
      eigyoshoList: 'DDMasters/mstEigyosho',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg',
      userEigyoshoCd: 'users/eigyoshoCd'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    filteredJininList () {
      const target = filter.dateFormatter(new Date())
      return this.jininList.map((elem) => {
        elem.jininNm = elem.jininNmSei + (elem.jininNmMei ? ' ' + elem.jininNmMei : '')
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target &&
        (self.eigyoshoLockFlg || elem.eigyoshoCd === self.userEigyoshoCd)
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.jininCd > elem2.jininCd) { return 1 }
        if (elem1.jininCd === elem2.jininCd) { return 0 }
        return -1
      })
    },
    filteredSeikyusakiList () {
      const target = filter.dateFormatter(new Date())
      return this.seikyusakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['vwcmsteigyoshojininlist', 'vwcmsttorihikisakigetseikyusaki', 'msteigyosho'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('D2BCLD0040.defineHeaderPromise')
            self.headers = [
              { text: '請求先', value: 'seikyusakiNm' },
              { text: '請求日', value: 'seikyuYmdDisp', align: 'center' },
              { text: '入金予定日', value: 'nyukinYoteiYmdDisp', align: 'center' },
              { text: '請求No', value: 'seikyuNo' },
              { text: '受注担当者', value: 'tantoNm' },
              { text: '請求金額', value: 'seikyuKingakuDisp', align: 'end' },
              { text: '入金金額', value: 'nyukinKingakuDisp', align: 'end' },
              { text: '未入金額', value: 'minyukinKingakuDisp', align: 'end' }]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              seikyusakiCd: '',
              nyukinYoteiYmdFromString: '',
              nyukinYoteiYmdToString: '',
              tantoCd: '',
              nyukinYoteiChoka: true
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('D2BCLD0040.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          if (Object.keys(c).length !== 0) {
            var nyukinYoteiChokaBool = c.nyukinYoteiChoka === 'true'
            self.conditions.nyukinYoteiChoka = nyukinYoteiChokaBool
          }
          console.log('D2BCLD0040.savedInputRestorePromise', self.conditions)
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('D2BCLD0040.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('D2BCLD0040.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.searchText = c.cache.value ? c.cache.value.searchText || '' : self.searchText
            self.rows = c.cache.value ? c.cache.value.rows || [] : self.rows
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      this.selected = []
      this.page = 1

      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/vwCD2bcld0040/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
            nyukinYoteiChoka: self.conditions.nyukinYoteiChoka
          }
        }
      }
      this.search(opt)
    },
    clear: function () {
      const self = this
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            self.conditions = {
              seikyusakiCd: '',
              nyukinYoteiYmdFromString: '',
              nyukinYoteiYmdToString: '',
              tantoCd: '',
              nyukinYoteiChoka: true
            }
            self.searchText = ''
            self.rows = []
            self.selected = []
            self.page = 1
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    onRowDoubleClick: function (e, f) {
      console.log(e, f)
      this.Effects.loadStart()
      this.transition(0, { id: f.item.id })
    },
    onRowEditButtonClick: function (item) {
      // 画面遷移
      this.Effects.loadStart()
      this.transition(0, { id: item.id })
    },
    eportButtonClick: function (e) {
      this.Effects.loadStart()
      console.log(e)
      // todo:レポート出力
      this.HttpClient
        .requestFileByPost('/api/v1/vwCD2bcld0040/pdfdownload', this.conditions)
        .then((data) => {
          const blob = new Blob([data], { type: 'application/pdf' })
          const elem = document.getElementById('pdfdownload')
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
          this.Effects.loadComplete()
        })
    },
    searchValidate: function () {
      console.log('searchValidate')
      // 入金予定日の大小チェック
      const msg = validators.compareDate(this.conditions.nyukinYoteiYmdFromString, this.conditions.nyukinYoteiYmdToString)
      if (msg !== undefined) {
        this.$refs.nyukinYoteiYmdFromString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.nyukinYoteiYmdToString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.setInvalidSummaryMessage('COME0014')
        return false
      }
      return true
    },
    dummyFunction: function () {

    }
  }
}
